import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faList } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import validator from 'validator'

const Add = () => {
  const auth = useSelector((state) => state.auth);
  const user = auth.user;

  const [submitted, setSubmitted] = useState(false);
  const [input, setInput] = useState({
    firstname: "",
    lastname: "",
    username: "",
    phone: "",
    gender: "",
  });
  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "") {
        error[item] = "Required";
      }

      if(input[item]) {
        switch(item) {
          case "phone":
            if(!validator.isNumeric(String(input['phone']))) {
              error[item] =  "Invalid phone number";
            }
            break;
          case "mentor_email":
            if(!validator.isEmail(input['mentor_email'])) {
              error[item] =  "Invalid email";
            }
            break;
          
          default:
            break;
        }
      }
    });
    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const submitForm = () => {
    setValidationError({});
    if(Object.keys(checkValidation()).length > 0) {
      return false;
    }
    // userService.profileSave(input).then(rslt => {
    //   qpr.basic_information = rslt.data.user;
    //   localStorage.setItem("qpr", JSON.stringify(qpr));
    //   dispatch(qprActions.qpr(qpr));
    // });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitForm();
  }
  return (
    <>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h5>
                  Team
                  <Link to={"/user/team"} className="ml-2">
                    <FontAwesomeIcon icon={faList} title="List of team" />
                  </Link>
                </h5>
              </div>
              <div className='mt-4'>
              <div className='card border-info' style={{"borderTop": "3px solid"}}>
                  <div className='card-body'>
                    <div className="contact-from pt-0">
                      <div className="main-form">
                        <form onSubmit={handleSubmit} data-submit_status={1}>
                          <div className='row'>
                            <div className="col-md-6 singel-form">
                              <label>First Name<span className='text-danger'>*</span>:</label>
                              <input name="firstname" type="text" value={input.firstname} ref={r => {ref.current['firstname'] = r}} onChange={handleChange} />
                              {validationError.firstname && <span className='text-danger'>{validationError.firstname}</span>}
                            </div>
                            <div className="col-md-6 singel-form">
                              <label>Last Name<span className='text-danger'>*</span>:</label>
                              <input name="lastname" type="text" value={input.lastname} ref={r => {ref.current['lastname'] = r}} onChange={handleChange} />
                              {validationError.lastname && <span className='text-danger'>{validationError.lastname}</span>}
                            </div>
                          </div>
                          <div className='singel-form'>
                            <label>Email<span className='text-danger'>*</span>:</label>
                            <input name="username" type="text" value={input.username} ref={r => {ref.current['username'] = r}} onChange={handleChange} />
                            {validationError.username && <span className='text-danger'>{validationError.username}</span>}
                          </div>
                          <div className='singel-form'>
                            <label>Gender<span className='text-danger'>*</span>:</label>
                            <input name="gender" type="text" value={input.gender} ref={r => {ref.current['gender'] = r}} onChange={handleChange} />
                            {validationError.gender && <span className='text-danger'>{validationError.gender}</span>}
                            {/* <select name='gender'>
                              <option value={""}>Select</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </select> */}
                          </div>
                          <div className='singel-form'>
                            <label>Country<span className='text-danger'>*</span>:</label>
                            <input name="nationality_id" type="text" value={input.nationality_id} ref={r => {ref.current['nationality_id'] = r}} onChange={handleChange} />
                            {validationError.nationality_id && <span className='text-danger'>{validationError.nationality_id}</span>}
                          </div>
                          <div className='singel-form'>
                            <label>Phone<span className='text-danger'>*</span>:</label>
                            <input name="phone" type="text" value={input.phone} ref={r => {ref.current['phone'] = r}} onChange={handleChange} />
                            {validationError.phone && <span className='text-danger'>{validationError.phone}</span>}
                          </div>
                          <hr/>
                          <p className="form-message"></p>
                          <div className="singel-form">
                            <button type="submit" className="main-btn btn-info disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Save</span>}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Add;